import { NgModule } from '@angular/core';

import { ThemeModule } from '../../../@theme/theme.module';
import { WelcomeComponent } from './welcome.component';

@NgModule({
  imports: [
    ThemeModule,
  ],
  declarations: [
    WelcomeComponent,
  ],
})
export class WelcomeModule { }
